import { createFileRoute } from '@tanstack/react-router';
import { MyFatoorahTransactionsPage } from '@/modules/payments/pages/MyFatoorahTransactionsPage';

export const Route = createFileRoute('/dashboard/payments/myfatoorah/')({
  component: MyFatoorahTransactionsPage,
});
